import type { AuthEvent } from './events';
import type { AuthContext } from './types';
import type { ActionArgs as XStateActionArgs } from 'xstate';

// ─────────────────────────────────────────────────────────────────────────────

const SESSION_RETRY_DELAY: Delay = ({ context }) => {
  return getSessionRetryDelay(context.sessionFailureCount);
};

export const AuthMachineDelays = {
  SESSION_RETRY_DELAY,
};

export function getSessionRetryDelay(sessionFailureCount: number) {
  const delayIndex = Math.min(sessionFailureCount, SESSION_RETRY_DELAY_SCHEDULE.length) - 1;

  return SESSION_RETRY_DELAY_SCHEDULE[delayIndex];
}

// ─── Constants ───────────────────────────────────────────────────────────────

const SESSION_RETRY_DELAY_SCHEDULE = [0, 5_000, 15_000, 30_000];

// ─── Types ───────────────────────────────────────────────────────────────────

type Delay = (args: XStateActionArgs<AuthContext, AuthEvent, AuthEvent>) => number;
